module.exports = __webpack_public_path__ + "img/fish-net.c7a8683b.png";